import { MatDialogRef } from '@angular/material/dialog';
import { Renderer2 } from '@angular/core';

interface IHideDialogData {
    dialog: HTMLElement;
    displayValue: string;
}

export function hideAllMatDialogs<T>(modalRefFactory: () => MatDialogRef<T>, renderer: Renderer2): MatDialogRef<T> {
    // 1. Hide currently opened dialogs
    const openedDialogOverlaysAndDisplayValues: IHideDialogData[] = [];
    Array.from(document.getElementsByClassName('cdk-global-overlay-wrapper')).forEach((el: HTMLElement) => {
        openedDialogOverlaysAndDisplayValues.push({
            dialog: el,
            displayValue: el.style.display,
        });
        renderer.setStyle(el, 'display', 'none');
    });

    // 2. Hide all opened overlays by removing "showing" class. This allow to remove them in transition with new backdrop
    const backdrops = Array.from(document.getElementsByClassName('cdk-overlay-backdrop'));
    backdrops.forEach((backdropEl) => renderer.removeClass(backdropEl, 'cdk-overlay-backdrop-showing'));
    // 3. Open dialog
    const modalRef = modalRefFactory();
    // 4. Before close new dialog - display all other dialogs by adding "showing" class without transition.
    // No transition needed because closed "modalRef" removes his backdrop immediately
    modalRef.beforeClosed().subscribe(() => {
        openedDialogOverlaysAndDisplayValues.forEach((dialogsStash) => {
            renderer.setStyle(dialogsStash.dialog, 'display', dialogsStash.displayValue);
        });
        backdrops.forEach((el: Element) => {
            renderer.setStyle(el, 'transition', 'none');
            renderer.addClass(el, 'cdk-overlay-backdrop-showing');
        });
    });
    // 5. Restore transitional showing to initial state
    modalRef.afterClosed().subscribe(() => {
        backdrops.forEach((el: Element) => renderer.setStyle(el, 'transition', ''));
    });
    return modalRef;
}
